/*
* Automatically generated by 'ng g ng-alain:plugin icon'
*/

import {
  AimOutline,
  BorderLeftOutline,
  BorderRightOutline,
  CopyrightOutline,
  EnvironmentOutline,
  FullscreenExitOutline,
  FullscreenOutline,
  GlobalOutline,
  LockOutline,
  LogoutOutline,
  SettingOutline,
  ToolOutline,
  UserOutline
} from '@ant-design/icons-angular/icons';

export const ICONS_AUTO = [
  AimOutline,
  BorderLeftOutline,
  BorderRightOutline,
  CopyrightOutline,
  FullscreenExitOutline,
  FullscreenOutline,
  GlobalOutline,
  LockOutline,
  LogoutOutline,
  SettingOutline,
  ToolOutline,
  UserOutline,
  EnvironmentOutline
];
